import { useAtom, atom } from 'jotai';
import { LeadInvoice } from '../pages/main';

const leadInvoice = atom<LeadInvoice | null>(null);

export const useLeadInvoiceStore = () => {
  const [leadInvoiceState, setLeadInvoiceState] = useAtom(leadInvoice);

  const clear = () => {
    setLeadInvoiceState(null);
  };

  return { leadInvoiceState, setLeadInvoiceState, clear };
};
